// extracted by mini-css-extract-plugin
export default {"container":"BlurImageEditor_container__Qqx8m","tollsBlock":"BlurImageEditor_tollsBlock__6Qc3F"};